import { PropsWithChildren, ReactElement, ReactNode } from "react";
import { IconType } from "react-icons/lib";
import "./iconButton.css";

interface PropsI {
  Icon?: IconType | (() => ReactNode);
  children?: ReactNode;
  style?: { [key: string]: string | number };
  size?: "sm" | "lg";
  className?: string;
  withoutBackground?: boolean;
  variant?: "error";
}

export const IconButton = ({
  Icon,
  style = {},
  onClick,
  size,
  withoutBackground,
  className,
  children,
  variant,
  ...props
}: PropsWithChildren<PropsI & Record<string, any>>): ReactElement => {
  return (
    <button
      className={`btn-icon ${variant ? variant : ""} ${size ? size : ""} ${withoutBackground ? "btn-icon-no-background" : ""} ${className ? className : ""}`}
      style={style}
      onClick={onClick}
    >
      {Icon ? <Icon {...props}></Icon> : children}
    </button>
  );
};
